import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import BusinessModel from "@/components/site/BusinessModel";
import Karnataka from "@/components/site/Karnataka";
import Leadership from "@/components/site/Leadership";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import WhoWeServe from "@/components/site/WhoWeServe";
import WhyRudra from "@/components/site/WhyRudra";
import useSmoothScroll from "@/components/motion/useSmoothScroll";
import usePageMeta from "@/hooks/usePageMeta";

export default function Home() {
  useSmoothScroll();
  usePageMeta({
    title: "RUDRA EMPIRE | Strategic Land Acquisition & Consolidation | Karnataka",
    description:
      "RUDRA EMPIRE is a privately owned, family-led business house founded in 1995. Strategic land acquisition and consolidation in Karnataka; interests in coal mining in Jharkhand.",
    canonical: "https://rudraempire.com/",
  });
  return (
    <main data-testid="home-page" className="relative bg-[#08080A] text-neutral-100">
      <Header />
      <Hero />
      <BusinessModel />
      <WhoWeServe />
      <WhyRudra />
      <Karnataka />
      <Leadership />
      <Contact />
      <Footer />
    </main>
  );
}
